export enum PeriodEnum {
    Day = "Day",
    Week = "Week",
    Month = "Month",
}
